import React, { useState } from "react";
import { Link } from "react-router-dom";
import Banner from "../../assets/images/phylosophy2.png";
import "./phylosophy.scss";
import Image4 from "../../assets/images/cap.webp";
import Image1 from "../../assets/images/lecturers.JPG";
import Image2 from "../../assets/images/science-lab.png";
import Image3 from "../../assets/images/science-lab2.png";
import Image5 from "../../assets/images/15-1.jpg";
import Image6 from "../../assets/images/12-2.jpg";
import Image7 from "../../assets/images/graduate.png";
import ProgressBar from "./ProgressBar/ProgressBar";
import { Lecturers } from "../../components/Lecturers/Lectuerers";
import { lecturers } from "../../TextData";
export const Phylosophy = () => {
  const [state, setState] = useState({
    query: "",
    list: lecturers,
  });
  return (
    <>
      <div className="phylosophy-page">
        {" "}
        <center>
          <h1>Our Phylosophy</h1>
        </center>
        <div className="flexy flexyM offset-md-5 mt5">
          {" "}
          <Link to={"/"} className="home-link">
            HOME
          </Link>
          <span>
            <i class="icofont-rounded-right"></i>
          </span>
          <h6>About</h6>
        </div>
      </div>

      <center>
        <div className="col-md-6 mt7">
          <h3>PHILOSOPHY OF THE PROGRAMME</h3>
          <div className="flexy flexyM col-md-2 ">
            {" "}
            <div className="bbb ">&nbsp;</div>
            <img className="" src={Image4} alt="Scholar" width="20%" />
            <div className="bbb ">&nbsp;</div>
          </div>
          <p className="mt2 mobile-padding">
            The underlying philosophy for the B.Sc. degree programme in physics
            is to essentially inform and educate on the structure and physical
            characteristics of matter and the earth. The ripple effects are
            applying the principles to solving human problems and provision of
            societal and industrial needs.
          </p>
        </div>
      </center>
      <div className="col-md-8 offset-md-2 t mobile-padding">
        <div className="flexy mt">
          <div className="col-md-6">
            <div className="col-md-11">
              {" "}
              <h5>OUR VISION</h5>
              <p>
                To become world class physics department and learning centre for
                the enhancement of the technological capacity of our Nation and
                the World at large. To place the department of physics
                University of Port Harcourt among the top five in Nigeria and
                among the top ten in Africa in the next five years.
              </p>
            </div>
          </div>
          <div className="col-md-6">
            <img className="" src={Image5} alt="Scholar" width="100%" />
          </div>
        </div>
        <div className="flexy mt">
          <div className="col-md-6">
            <div className="col-md-11">
              <img className="" src={Image6} alt="Scholar" width="100%" />
            </div>
          </div>
          <div className="col-md-6">
            <h5>OUR MISSION</h5>
            To lay solid foundations in Physics for students of physics and the
            Applied Physics, and Agricultural, Basic Health, Pharmaceutical
            sciences and Engineering for the intellectual application of physics
            laws and processes to gaining competence in problem solving,
            acquiring entrepreneurial skills, create environmental
            sustainability and attain technological development for the society.{" "}
          </div>
        </div>
        <div className="flexy mt">
          <div className="col-md-6">
            {" "}
            <div className="col-md-11 objs">
              <h5>OUR GOALS/OBJECTIVES</h5>
              <p>
                The goals and objectives of the Department of physics,
                University of Port Harcourt, Choba are:
              </p>{" "}
              <ul>
                <li>
                  {" "}
                  • Provision of broad-based knowledge in basic and applied
                  physics leading to a variety of career opportunities and
                  entrepreneurial skills in order to fit well into both the
                  public and private sectors of the so­ciety by using modern
                  teaching and learning techniques.
                </li>
                <li>
                  Exposure of students to theoretical and practical aspects of
                  physics in order to provide full knowledge of most areas of
                  physics.
                </li>
                <li>
                  Running an academic programme that is based on early exposure
                  of students to specific areas of specialization from the
                  undergradu­ate level.
                </li>
                <li>
                  Stimulation, sensitization and motivation of postgraduate
                  students to undertake scientifically productive research works
                  that could yield cutting edge results which can be translated
                  into industrial devel­opment.
                </li>
                <li>
                  Involvement in intradepartmental, interdepartmental and
                  inter-fac­ulty collaborative teaching and research efforts in
                  order to reap the fruitful harvest of productive research
                  findings and results.
                </li>
                <li>
                  Collaboration with relevant industries to carry out
                  industry-based pro­ject works whose result will have direct
                  application to industrial development and the materials needs
                  of the society.
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-6">
            <img className="" src={Image7} alt="Scholar" width="100%" />
          </div>
        </div>
      </div>
      <div className="phy-body mt2">
        <center>
          <h1>WHO WE ARE</h1>
        </center>
        <div className="flexy flexyM offset-md-5 col-md-2 offset-2">
          {" "}
          <div className="bb ">&nbsp;</div>
          <img className="" src={Image4} alt="Scholar" width="20%" />
          <div className="bb ">&nbsp;</div>
        </div>
        <div className="col-md-8 offset-md-2 flexy mobile-padding">
          <div className="col-md-6 mt8">
            <div className="col-md-11">
              <h3>Definitively Morally Conscious</h3>
              <p>
                At the heart of our department's philosophy lies a commitment to
                being definitively morally conscious. We firmly believe that the
                pursuit of scientific knowledge goes hand-in-hand with ethical
                responsibility. In an age where scientific advancements have
                profound consequences, we emphasize the importance of conducting
                research and teaching with the highest ethical standards. Our
                faculty and students are guided by a strong sense of integrity,
                ensuring that the knowledge and discoveries we generate are used
                for the betterment of humanity.
                <p>
                  We instill in our students not only a deep understanding of
                  physics but also a strong moral compass, preparing them to
                  navigate the complex ethical challenges that can arise in the
                  world of science and technology.
                </p>
              </p>
            </div>
          </div>
          <div className="col-md-6 mt8">
            {" "}
            <img className="" src={Image1} alt="Scholar" width="100%" />
          </div>
        </div>
        <div className="col-md-8 offset-md-2 flexy  mobile-padding">
          <div className="col-md-6 mt8">
            {" "}
            <div className="col-md-11">
              {" "}
              <img className="" src={Image2} alt="Scholar" width="100%" />
            </div>
          </div>
          <div className="col-md-6 mt8">
            <h3>Research Based Academic Approach</h3>
            <p>
              Our department thrives on a research-based academic approach. We
              understand that true learning occurs when students actively engage
              with the subject matter and contribute to the body of knowledge.
              Therefore, research is not just an option; it's an integral part
              of our curriculum. Through hands-on experiments, collaborative
              projects, and faculty-led research initiatives, students are
              encouraged to explore the frontiers of physics. This approach not
              only deepens their understanding of the subject but also equips
              them with valuable skills in critical thinking, problem-solving,
              and scientific inquiry. We firmly believe that this
              research-centric approach prepares our graduates to excel in
              academia, industry, and various scientific endeavors.
            </p>
          </div>
        </div>
        <div className="col-md-8 offset-md-2 flexy  mobile-padding">
          <div className="col-md-6 mt8">
            <div className="col-md-11">
              <h3>Experimental & Theoritical Learning Approach</h3>
              <p>
                At the University of Port Harcourt's Department of Physics, we
                embrace both experimental and theoretical learning approaches.
                Physics is a discipline that thrives on the synergy between
                theory and experimentation. We provide students with a
                well-rounded education that includes hands-on laboratory
                experiences to reinforce theoretical concepts. This holistic
                approach ensures that our graduates are not only equipped with a
                solid theoretical foundation but also possess the practical
                skills needed to apply their knowledge to real-world challenges.
                By balancing these two essential aspects of physics education,
                we empower our students to be versatile, adaptable, and
                well-prepared for the diverse opportunities that await them in
                the field of physics.
              </p>
            </div>
          </div>
          <div className="col-md-6 mt8">
            {" "}
            <img className="" src={Image3} alt="Scholar" width="100%" />
          </div>
        </div>

        <center>
          <h1 className="mt">WHAT WE TAKE PRIDE IN</h1>
        </center>
        <div className="flexy flexyM offset-md-5 col-md-2 offset-2">
          {" "}
          <div className="bb ">&nbsp;</div>
          <img className="" src={Image4} alt="Scholar" width="20%" />
          <div className="bb ">&nbsp;</div>
        </div>
        <div className="algorithyms col-md-8 offset-md-2 flexy ">
          <ProgressBar />
        </div>
      </div>

      <center>
        <h1 className="mtt">Our Leadership</h1>
      </center>
      <div className="row row-cols-2 row-cols-lg-4  g-lg-2 col-md-8 offset-md-2 mt8">
        {state.list.map((data, index) => (
          <Lecturers data={data} />
        ))}
      </div>
    </>
  );
};
